module.exports = __webpack_public_path__ + "static/img/3.fcd40747.jpg";